export default {"src":"/_next/static/media/note.d5246fbd.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};